import React from "react";
import { Globe, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LANGUAGES } from "@/i18n";
import { useTranslation } from "@/context/LanguageContext";
import { cn } from "@/lib/utils";

export const LanguageSwitcher = ({ variant = "default", align = "end", className, testId = "language-switcher-trigger" }) => {
    const { lang, changeLanguage } = useTranslation();
    const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    data-testid={testId}
                    variant="ghost"
                    size={variant === "compact" ? "icon" : "sm"}
                    className={cn("gap-1.5 text-t2 hover:text-t1", className)}
                    aria-label="Change language"
                >
                    <Globe className="h-4 w-4" />
                    {variant !== "compact" && <span className="text-sm font-medium">{current.short}</span>}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align={align} className="min-w-[168px] border-border bg-surface-1">
                {LANGUAGES.map((l) => (
                    <DropdownMenuItem
                        key={l.code}
                        data-testid={`language-option-${l.code}`}
                        onClick={() => changeLanguage(l.code)}
                        className="flex cursor-pointer items-center gap-2.5 text-t2 focus:bg-surface-3 focus:text-t1"
                    >
                        <span className="text-base leading-none">{l.flag}</span>
                        <span className="flex-1">{l.label}</span>
                        {l.code === lang && <Check className="h-4 w-4 text-[hsl(var(--primary))]" />}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
